import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ContactClientCreateComponent } from '../../contact/contact-client-create/contact-client-create.component'
import { MatDividerModule } from '@angular/material/divider'
import { NgxMaskDirective } from 'ngx-mask'
import { ViaCepService } from '../../../core/services/address/via-cep/via-cep.service'
import { EmployeeStatusService } from '../../../core/services/employee/employee-status/employee-status.service'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import { EmployeeRoleService } from '../../../core/services/employee/employee-role/employee-role.service'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { emailValidator } from '../../../shared/utils/email_validator'
import moment from 'moment/moment'
import { cpfValidator } from '../../../shared/utils/cpf_validator'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { ProfileService } from '../../../core/services/profile/profile.service'

@Component({
  selector: 'employee-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    MatOption,
    MatSelect,
    MatDividerModule,
    ContactClientCreateComponent,
    NgxMaskDirective,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSlideToggle,
  ],
  templateUrl: './employee-create.component.html',
  styleUrl: './employee-create.component.scss',
  providers: [
    ViaCepService,
    EmployeeStatusService,
    EmployeeService,
    EmployeeRoleService,
    AddressTypeService,
  ],
  standalone: true,
})
export class EmployeeCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private viaCepService: ViaCepService,
    private employeeStatusService: EmployeeStatusService,
    private employeeService: EmployeeService,
    private addressTypeService: AddressTypeService,
    private profileService: ProfileService,
    private employeeRoleService: EmployeeRoleService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<EmployeeCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    const currentDay = today.getDate()
    this.maxDate = new Date(currentYear - 18, currentMonth, currentDay)
  }

  @Output() responseCreate = new EventEmitter()
  @ViewChild('birth') datepickerBirth: MatDatepicker<any> | undefined
  @ViewChild('hiring') datepickerHiring: MatDatepicker<any> | undefined

  formEmployee: FormGroup = new FormGroup({})
  maxDate!: Date

  loading: boolean = false

  listAddressType: any[] = []
  listStatusEmployee: any[] = []
  listRoleEmployee: any[] = []

  listProfile: any[] = []

  contactList: any[] = []

  ngOnInit(): void {
    this.getAddressType()
    this.getRoleEmployee()
    this.getStatusEmployee()
    this.getProfiles()
    this.createForm()
  }

  close() {
    this.dialogRef.close()
  }

  onChangeIsUser() {
    if (this.formEmployee.get('isUser')?.value == true) {
      this.formEmployee.get('profile')!.setValidators(Validators.required)
      this.formEmployee
        .get('password')!
        .setValidators([Validators.required, Validators.minLength(3)])
    } else {
      this.formEmployee.get('profile')!.clearValidators()
      this.formEmployee.get('password')!.clearValidators()
    }
    this.formEmployee.get('profile')!.updateValueAndValidity()
    this.formEmployee.get('password')!.updateValueAndValidity()
  }

  getProfiles() {
    this.profileService.listProfileFilter().subscribe({
      next: (response: any) => {
        let list = []
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          list.push({
            id: element.id,
            description: element.descricao,
          })
        }
        this.listProfile = list
      },
      error: (err: any) => {},
      complete: () => {},
    })
  }

  getAddressType() {
    this.addressTypeService.listAddressType().subscribe({
      next: (response: any) => {
        let list = []
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          list.push({
            id: element.id,
            description: element.descricao,
          })
        }
        this.listAddressType = list
      },
      error: (err: any) => {},
      complete: () => {},
    })
  }

  getRoleEmployee() {
    this.employeeRoleService.listEmployeeRole().subscribe({
      next: (response: any) => {
        let list = []
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          list.push({
            id: element.id,
            description: element.descricao,
          })
        }
        this.listRoleEmployee = list
      },
      error: (err: any) => {},
      complete: () => {},
    })
  }

  getStatusEmployee() {
    this.employeeStatusService.listEmployeeStatus().subscribe({
      next: (response: any) => {
        let list = []
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          list.push({
            id: element.id,
            description: element.descricao,
          })
        }
        this.listStatusEmployee = list
      },
      error: (err: any) => {},
      complete: () => {},
    })
  }

  createModel() {
    console.log('form', this.formEmployee)
    return {
      funcionario: {
        funcionarioFuncaoId: this.formEmployee.get('roleEmployee')?.value,
        statusId: this.formEmployee.get('statusEmployee')?.value,
        nome: this.formEmployee.get('name')?.value,
        email: this.formEmployee.get('email')?.value,
        cpf: this.formEmployee.get('cpf')?.value,
        matricula: this.formEmployee.get('registration')?.value,
        dataNascimento:
          this.formEmployee.get('birth')?.value != ''
            ? moment(this.formEmployee.get('birth')?.value).format('DD/MM/YYYY')
            : '',
        dataContratacao:
          this.formEmployee.get('hiring')?.value != ''
            ? moment(this.formEmployee.get('hiring')?.value).format(
                'DD/MM/YYYY',
              )
            : '',
        isUsuario: this.formEmployee.get('isUser')?.value ? 'S' : 'N',
        senha:
          this.formEmployee.get('password')?.value != ''
            ? this.formEmployee.get('password')?.value
            : '',
        idPerfil:
          this.formEmployee.get('profile')?.value != ''
            ? this.formEmployee.get('profile')?.value
            : 0,
      },
      endereco: {
        tipo_endereco_id: this.formEmployee.get('addressType')?.value,
        cep: this.formEmployee.get('postalCode')?.value,
        logradouro: this.formEmployee.get('street')?.value,
        bairro: this.formEmployee.get('neighborhood')?.value,
        numero: this.formEmployee.get('number')?.value,
        complemento: this.formEmployee.get('complement')?.value,
        cidade: this.formEmployee.get('city')?.value,
        estado: this.formEmployee.get('state')?.value,
        pais: this.formEmployee.get('country')?.value,
        latitude: '',
        longitude: '',
      },
      contatos: this.contactList.map(
        ({ tipoContato, idCreate, ...remainder }) => remainder,
      ),
    }
  }

  createForm(): void {
    this.formEmployee = this.formBuilder.group({
      // Employee fields
      roleEmployee: ['', [Validators.required]],
      statusEmployee: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, emailValidator()]],
      cpf: ['', [Validators.required, cpfValidator()]],
      birth: ['', [Validators.required]],
      registration: [''],
      hiring: [''],
      // isUser: [false],
      // Adress fields
      addressType: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      street: ['', [Validators.required]],
      number: ['', [Validators.required]],
      neighborhood: ['', [Validators.required]],
      complement: [''],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      country: ['', [Validators.required]],

      isUser: [false],
      profile: [''],
      password: [''],
    })
  }

  fillFormViaCep(element: any) {
    if (element.erro) {
      this.formEmployee.get('street')?.setValue('')
      this.formEmployee.get('number')?.setValue('')
      this.formEmployee.get('complement')?.setValue('')
      this.formEmployee.get('neighborhood')?.setValue('')
      this.formEmployee.get('city')?.setValue('')
      this.formEmployee.get('state')?.setValue('')
      this.formEmployee.get('country')?.setValue('')
    } else {
      this.formEmployee.get('street')?.setValue(element.logradouro)
      this.formEmployee.get('number')?.setValue('')
      this.formEmployee.get('complement')?.setValue(element.complemento)
      this.formEmployee.get('neighborhood')?.setValue(element.bairro)
      this.formEmployee.get('city')?.setValue(element.localidade)
      this.formEmployee.get('state')?.setValue(element.estado)
      this.formEmployee.get('country')?.setValue('Brasil')
    }
  }

  getAddressByPostalCode() {
    let postalCode = this.formEmployee.get('postalCode')?.value
    if (postalCode != '' && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (response: any) => {
          this.fillFormViaCep(response)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
    }
  }

  getList(list: any[]) {
    this.contactList = list
  }

  createEmployee() {
    this.loading = true
    this.employeeService.createEmployee(this.createModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        // this.formIndividual.reset()
        // this.formFinancial.reset()
      },
    })
  }

  openDatepicker(datePicker: 'hiring' | 'birth') {
    if (this.datepickerBirth && datePicker == 'birth') {
      this.datepickerBirth.open()
    }
    if (this.datepickerHiring && datePicker == 'hiring') {
      this.datepickerHiring.open()
    }
  }
}
